<template>
  <v-card>
    <v-card-actions class="controls">
      <v-icon :disabled="isLoading" @click="$emit('close')">
        close
      </v-icon>

      <div class="dialog-title">
        <slot />
        <slot name="export"></slot>
      </div>

      <v-spacer />

      <v-btn
        :loading="isLoading"
        :disabled="isDisabled || isLoading || isPristine"
        color="#fff"
        text
        @click="$emit('save')"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    props: {
      isLoading: Boolean,
      isPristine: Boolean,
      isDisabled: Boolean
    },
    emits: [ 'close', 'save' ]
  }
</script>

<style lang="scss" scoped>
  .controls {
    background-color: #4EAF50;
    border-radius: 0 !important;

    .v-icon,
    .dialog-title {
      color: #fff !important;
    }

    .dialog-title {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      text-transform: uppercase;
      margin-left: 0.875rem;
      width: 100%;
    }
  }
</style>
